/* lf-faq-accordion — exclusive open/close, height + opacity reveal.

   One row open at a time per section: opening a row collapses whichever sibling
   was open, both transitions running together rather than snapping.
   Every row starts closed.

   max-height is animated to the measured scrollHeight, then released to `none`
   once the transition lands, so a reflowed answer (resize, font swap) is never
   clipped by a stale pixel value.

   Under prefers-reduced-motion the swap is instant — the exclusivity still
   holds, only the animation is dropped. */
(function () {
  var ROOT = '[data-lf-faq]';
  var ITEM = '[data-lf-faq-item]';
  var TOGGLE = '[data-lf-faq-toggle]';
  var PANEL = '[data-lf-faq-panel]';

  var reduceQuery = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;

  function reduced() {
    return !!(reduceQuery && reduceQuery.matches);
  }

  // Collapse whichever sibling in the same section is open. Called before the
  // incoming row expands, so the two transitions overlap.
  function closeSiblings(item) {
    var root = item.closest ? item.closest(ROOT) : null;
    if (!root) return;

    root.querySelectorAll(ITEM).forEach(function (other) {
      if (other !== item && other.dataset.open === 'true') close(other);
    });
  }

  function open(item) {
    var panel = item.querySelector(PANEL);
    var toggle = item.querySelector(TOGGLE);
    if (!panel || !toggle) return;

    closeSiblings(item);

    item.dataset.open = 'true';
    toggle.setAttribute('aria-expanded', 'true');
    panel.removeAttribute('inert');
    panel.style.maxHeight = reduced() ? 'none' : panel.scrollHeight + 'px';
  }

  function close(item) {
    var panel = item.querySelector(PANEL);
    var toggle = item.querySelector(TOGGLE);
    if (!panel || !toggle) return;

    if (!reduced()) {
      // Released to `none` while open, so pin the measured height before
      // collapsing or the transition has nothing to animate from.
      panel.style.maxHeight = panel.scrollHeight + 'px';
      void panel.offsetHeight;
    }

    item.dataset.open = 'false';
    toggle.setAttribute('aria-expanded', 'false');

    // `inert` drops focus to <body> if it lands on something inside the panel,
    // so hand it back to this row's own toggle first. Never fires on an
    // auto-close: activating another toggle has already moved focus out of here.
    if (panel.contains(document.activeElement)) toggle.focus();

    panel.setAttribute('inert', '');
    panel.style.maxHeight = '0px';
  }

  function initItem(item) {
    var panel = item.querySelector(PANEL);
    var toggle = item.querySelector(TOGGLE);
    if (!panel || !toggle) return;

    panel.style.maxHeight = '0px';

    toggle.addEventListener('click', function () {
      if (item.dataset.open === 'true') {
        close(item);
      } else {
        open(item);
      }
    });

    panel.addEventListener('transitionend', function (event) {
      if (event.propertyName !== 'max-height') return;
      if (item.dataset.open === 'true') panel.style.maxHeight = 'none';
    });
  }

  function init(root) {
    if (!root || root.dataset.lfFaqReady === 'true') return;
    root.dataset.lfFaqReady = 'true';
    root.querySelectorAll(ITEM).forEach(initItem);
  }

  function initAll(scope) {
    (scope || document).querySelectorAll(ROOT).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  // Selecting a question in the theme editor opens it, so the merchant can see
  // the answer they are editing.
  document.addEventListener('shopify:block:select', function (event) {
    var item = event.target.closest ? event.target.closest(ITEM) : null;
    if (item) open(item);
  });

  document.addEventListener('shopify:block:deselect', function (event) {
    var item = event.target.closest ? event.target.closest(ITEM) : null;
    if (item) close(item);
  });
})();
